/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import mbpLogger from 'mbp-logger';
import { useDispatch, useSelector } from 'react-redux';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { setNewProductCardLayoutEnabled } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';

const NewProductSFAbTest = () => {
    const dispatch = useDispatch();
    const interactionName = 'any - precheckout - new product card - v1';
    const newProductCardEnabled = useSelector((state) => state?.mfeCheckout?.app?.abTest?.newProductCardEnabled);
    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        queryName: 'isNewProductCardUpdate',
        interactionName,
        featureFlag: true,
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    if ((loading) || (!loading && !data && !error)) {
        return null;
    }

    if (error) {
        mbpLogger.logError({
            function: 'Product Card Price Update',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Product Card Salesforce AB test returned an error',
            jsError: error,
        });
    }
    if (data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup && data?.contentSF?.campaign?.campaignResponses?.[0]?.payload?.userGroup !== newProductCardEnabled?.campaign?.campaignResponses?.[0]?.payload?.userGroup) {
        dispatch(setNewProductCardLayoutEnabled(data.contentSF));
    }

    return null;
};

export default NewProductSFAbTest;
